

import SearchBar from "./components/SearchBar";
import "./styles.css"
import DonorData from './donors_data.json';
import slides from './slider_data.json';
import React, { useState, useRef, useEffect } from "react";
// import DonorDetail from "./components/DonorDetail";
import Location from "./components/Location";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import MarianGarden from "./pages/MarianGarden";
import Masstime from "./pages/Masstime";
import Footer from './components/Footer';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay, EffectCube } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import 'swiper/css/effect-cube';
import "./fonts/Helvetica-Neue-Bold.ttf";
import "./fonts/Helvetica-Neue-Light.ttf";
import "./fonts/Neutraface-Display-Medium.ttf";


function App() {

  const [showSlider, setShowSlider] = useState(true);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setShowSlider((prev) => !prev);
    }, 129000); // 2 minutes in milliseconds

    return () => clearInterval(intervalId); // Clear interval on component unmount
  }, []);




const swiperRef = useRef(null);


  return (
    <Router>
    <div className="App">
    { showSlider
      ?
     (
     <Swiper
      modules={[EffectCube,Navigation, Pagination, Scrollbar, A11y, Autoplay]}
      spaceBetween={50}
      slidesPerView={1}
      scrollbar={{ enabled: false }} // Disable the scrollbar
      
      // navigation
      autoplay={{
        delay: 9000,
        disableOnInteraction: false,
      }}

      onSwiper={(swiper) => {
        swiperRef.current = swiper;
      }}


      pagination={{ clickable: true }}
      // allowTouchMove={false} // Disable swipe to change slides
      // scrollbar={{ draggable: false }}
     
      onSlideChange={() => console.log('slide change')}
      // onSwiper={(swiper) => console.log(swiper)}
      effect={'cube'}
      cubeEffect={{
        shadow: true,
        slideShadows: true,
      
        shadowOffset: 20,
        shadowScale: 0.94,
      }}
    >
    {slides.map((slide) => (
      <div className='swiper-slide'>
   
      <SwiperSlide key={slide.id}>
      <div className="slide-title">
      <h1>{slide.title}</h1> 
      </div>
      
      {/**<Link to="/welcome"> */}
        <img src={slide.image} alt={slide.alt_image} />
       {/**</Link>*/}
          <div className='slide-content'>
        
        
       
          </div>
          <div className='slide-footer-right'>
      
          </div>
          <div className="slide-footer-left">
           { /***
             slide.touch_me ? <Link to="/welcome"><img style= {{ display:'block', margin: '0 auto',height:200 , width:200}} src={slide.touch_me} alt="Touch Me" /></Link> : <p style={{height:200}}>&nbsp;</p>
              */
           } 
        
          <div className="footer-spacing">
        { /***   <p>TO DONATE:</p>
           <img style= {{ display:'block', margin: '0 auto',height:300 , width:300}}  src={qrcode} alt="Donate QR Code" class="src" />
             <p>ZELLE:(657) 324-8277</p>
             */ }
         </div>
          </div>     
        
      </SwiperSlide>
      </div>
  ))}
 
  
      </Swiper>
    )  
     :
     (
    //  {/*beginning of map */}
  <Masstime />
 
  
       

  
    )

// end of map
}
       
{/** <Footer/>*/}

</div>
</Router>

  );
}

export default App;
